import React, { useState, useEffect } from "react";
import "views/MediaSection/ImageTools/Create/ImgGen.css";
import "font-awesome/css/font-awesome.min.css";
import { toastAlert } from "components/toastAlert/toastAlert";
import { useTranslation } from "react-i18next";
import UpgradeModal from "components/UpgradeModal/UpgradeModal";
import { useDispatch, useSelector } from "react-redux";
import UpgradePlanModal from "components/UpgradeModal/UpgradePlanModal";
import { handleClipAudio } from "redux/actions/media_section";
import Loading_v2 from "components/Loading/Laoadingv2/Loadingv2";
import ReplayIcon from "@mui/icons-material/Replay";
import { handleClipAudioLoading } from "redux/actions/media_section";
import clipAudioImage from "assets/img/newDesign/Group 9312 (1).png";
import FileContainer from "components/MediaSection/FileContainer";

import LimitPopUp from "views/plansComponent/LimitPopUp";
const ClipAudio = () => {
  let lng = JSON.parse(localStorage.getItem("language"))?.lang;
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [totalImages, setTotalImages] = useState(0);
  const user = useSelector((state) => state.user);
  const clipAudio = useSelector((state) => state.clip_audio);
  const dispatch = useDispatch();
  const [width, setWidth] = useState(window.innerWidth);
  const [show, setShow] = useState(false);
  const [loadingText, setLoadingText] = useState("Uploading your Image");

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  const [errors, setError] = useState("");
  let error_valid = lng === "arab" ? "" : "Only MP3, WAV, and MPEG audio files are allowed";

  useEffect(() => {
    setTotalImages(user?.image_count_left);
    if (user?.plan === "Trial" || user?.plan === "Starter") {
      return setShow(true);
    }
  }, [user]);
  useEffect(() => {
    if (clipAudio?.loading) {
      let intervalTime;
      if (clipAudio?.loadingNumber >= 1 && clipAudio?.loadingNumber < 25) {
        intervalTime = 3000 / 25; // 5 seconds for 1-25, increment by 1 every 200ms
        setLoadingText("Uploading Your Audio");
      } else if (clipAudio?.loadingNumber >= 25 && clipAudio?.loadingNumber < 50) {
        intervalTime = 5000 / 25; // 20 seconds for 25-50, increment by 1 every 800ms
        setLoadingText("Analyzing Your Audio");
      } else if (clipAudio?.loadingNumber >= 50 && clipAudio?.loadingNumber < 75) {
        intervalTime = 10000 / 25; // 30 seconds for 50-75, increment by 1 every 1200ms
        setLoadingText("Separating The Audio");
      } else if (clipAudio?.loadingNumber >= 75 && clipAudio?.loadingNumber < 100) {
        intervalTime = 50000 / 25; // 10 seconds for 50-75, increment by 1 every 1200ms
        setLoadingText("Loading The Audio");
      }
      const timer = setInterval(() => {
        dispatch(handleClipAudioLoading(clipAudio?.loadingNumber, "clip_audio"));
      }, intervalTime);
      return () => {
        clearInterval(timer);
      };
    }
  }, [clipAudio?.loadingNumber, clipAudio?.loading]);
  console.log(clipAudio?.loadingNumber, "clipAudio?.loadingNumber");
  const handleAudioUpload = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    if (totalImages === 0) {
      dispatch({ type: "SHOW_CLIP_AUDIO_FALSE" });
      return setShowModal(true);
    } else {
      dispatch(handleClipAudio(formData));
    }
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    if (totalImages === 0) {
      dispatch({ type: "SHOW_CLIP_AUDIO_FALSE" });
      return setShowModal(true);
    } else {
      const file = await e.dataTransfer.files;
      if (file) {
        const allowedTypes = ["audio/mpeg", "audio/wav", "audio/mp3"];
        if (!allowedTypes.includes(file[0]?.type)) {
          toastAlert("Only MP3, WAV, and MPEG audio files are allowed.", undefined, "warning");
        } else if (allowedTypes.includes(file[0].type)) {
          handleAudioUpload(file[0]);
          dispatch({ type: "SHOW_CLIP_AUDIO_TRUE" });
          setDragging(false);
          setError();
        } else {
          setError(error_valid);
          toastAlert(error_valid, undefined, "warning");
        }
      } else setUploaded(true);
    }
  };

  const handleImageUpload = async (e) => {
    e.preventDefault();
    if (totalImages === 0) {
      dispatch({ type: "SHOW_CLIP_AUDIO_FALSE" });
      return setShowModal(true);
    } else {
      const file = await e.target.files;
      if (file) {
        const allowedTypes = ["audio/mpeg", "audio/wav", "audio/mp3"];
        if (allowedTypes.includes(file[0]?.type)) {
          handleAudioUpload(file[0]);
          dispatch({ type: "SHOW_CLIP_AUDIO_TRUE" });
          setDragging(false);
          setError();
        } else {
          toastAlert("Only MP3, WAV, and MPEG audio files are allowed.", undefined, "warning");
        }
      } else setUploaded(true);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragging(false);
  };

  return (
    <>
      {clipAudio?.loading ? (
        <div
          style={{
            height: "calc(100vh - 200px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loading_v2 loadingText={loadingText} setLoadingText={setLoadingText} loadingNumber={clipAudio?.loadingNumber} />
        </div>
      ) : clipAudio?.clipAudio?.length != 0 ? (
        <div style={{ position: "relative" }}>
          {clipAudio?.clipAudio?.length != 0 && (
            <>
              <div
                style={{
                  maxWidth: "600px",
                  minHeight: "300px",
                  margin: "auto",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <div className="audio_result">
                  <h4 style={{ margin: "0" }}>{t("Music :")} &nbsp;</h4> <audio src={clipAudio?.clipAudio?.data?.urls[0]} controls />
                </div>
                <div className="audio_result">
                  <h4 style={{ margin: "0" }}>{t("Vocals :")}</h4>
                  <audio src={clipAudio?.clipAudio?.data?.urls[1]} controls />
                </div>
              </div>
              <div className="beforeAfter-container">
                <div className="beforeafter-gray">
                  {/* <button className="download-btn" onClick={handleDownload}>
                    <i
                      className="fas fa-arrow-down"
                      style={{
                        fontSize: "medium",
                        margin: "0 10px",
                      }}
                    ></i>
                    {t("Download")}
                  </button> */}

                  <button
                    className="newupload"
                    onClick={() => {
                      dispatch({ type: "NEW_CLIP_AUDIO" });
                    }}
                  >
                    <ReplayIcon sx={{ transform: "scale(-1)", margin: "0 10px" }} />
                    {t("Try Again")}
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      ) : (
        <>
          <div className="image_gen_container">
            <div
              className="image_gen_header"
              style={{
                padding: width < 500 ? "10px" : "20px",
                alignSelf: "flex-start",
              }}
            >
              <h4 style={{ textAlign: lng === "arab" ? "right" : "left" }}>{t("Separate vocals from background music with audio precision seamlessly")}</h4>
              <p style={{ textAlign: lng === "arab" ? "right" : "left" }}>{t("vocal remover and music separation fast, easy and precise , just upload your audio and let twwt.Ai do the work.")}</p>
              <p>{t("Upload Audio:")}</p>
              {!clipAudio.showRemover && (
                <FileContainer
                  handleDrop={handleDrop}
                  handleDragOver={handleDragOver}
                  handleDragLeave={handleDragLeave}
                  handleUpload={handleImageUpload}
                  dragging={dragging}
                  types=".mp3,.wav"
                  support="MP3 and WAV"
                />
              )}

              {user?.plan === "Trial" ? <UpgradeModal images={true} setShowModal={setShowModal} showModal={showModal} /> : <LimitPopUp setShowModal={setShowModal} showModal={showModal} />}
              <UpgradePlanModal show={show} setShow={setShow} width={width} />
            </div>
            <div className="right_image_media">
              <img src={clipAudioImage} alt="clipAudio-example" width={"90%"} height={"90%"} />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ClipAudio;
